module.exports = __webpack_public_path__ + "img/design-from-scratch.1f1ac6b.png";